import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { CategoryRepository } from "@/repositories/category";
import { SubCategoryFormData } from "@/schemas/subcategory-form.schema.";

export const useCreateSubCategory = (categoryId: string) => {
  const categoriesRepository = useRef(new CategoryRepository());

  return useMutation({
    mutationFn: (data: SubCategoryFormData) =>
      categoriesRepository.current.addSubCategory(categoryId, data),
  });
};
